import React, { useEffect } from "react";
import CircleType from 'circletype';
import { Link } from "react-router-dom";

const Banner = () => {
    useEffect(() => {

        const curvedTextElements = document.querySelectorAll(".curved-circle--item");
        curvedTextElements.forEach((element) => {
            const options = JSON.parse(element.getAttribute("data-circle-text-options"));
            new CircleType(element).radius(options.radius);
        });
    }, []);
    return (
        <>
            <div className="banner-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-10">
                            <div
                                className="banner-hedding-two animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h1>
                                    We create Your Potential Business Goals{" "}
                                    <span>
                                        journey with expertise&nbsp;integrity and a personalized value
                                        approach.
                                    </span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-logo-text-two">
                    <p
                        className="animate zoomIn wow"
                        data-wow-duration="2000ms"
                        data-wow-delay="800ms"
                    >
                        Uniqo
                    </p>
                </div>
                <div className="banner-two__circle">
                    <Link to="/Aboutus" className="banner-two-icon">
                        <svg
                            width={13}
                            height={13}
                            viewBox="0 0 13 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1.95508 11.2104L12.1348 1.03075"
                                stroke="white"
                                strokeWidth="1.18984"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M1.03125 1.03061H12.1364V12.1357"
                                stroke="white"
                                strokeWidth="1.18984"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link>
                    <div className="curved-circle">
                        <div
                            className="curved-circle--item"
                            data-circle-text-options='{
              "radius": 91,
              "forceWidth": true,
              "forceHeight": true
          }'
                        >
                            &nbsp;YES! WE PROUDLY WORK ----------------------------
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Banner
